// components/Dashboard/alerts.tsx
import React from 'react';
import { useEffect, useState } from 'react';
import { NotificationProps } from '../../../../type';
import { useTranslate } from "../../../../hooks/LanguageProvider";
import { Button, Table } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { toTimestamp } from '../../../../utilities/functions';

const Notification: React.FC<NotificationProps> = ({ Notifications }) => {

  const { translate } = useTranslate();
  const [apiNotifications, setApiNotifications] = useState<any[]>(Array.isArray(Notifications) ? Notifications : []);
  const backendUrl = process.env.REACT_APP_BACKEND_URL;
  const previewNotifications = apiNotifications.slice(0, 10);

  useEffect(() => {
    let mounted = true;
    const id_user = localStorage.getItem("userid");

    if (!backendUrl || !id_user) return;

    fetch(`${backendUrl}/api/notification/search`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      mode: "cors",
      body: JSON.stringify({
        limitValue: 10,
        currentPage: 1,
        search: "",
        type: 0,
        id_user,
        column: "0",
        sort: "DESC",
      }),
    })
      .then((response) => {
        if (!response.ok) throw new Error("notifications failed");
        return response.json();
      })
      .then((data) => {
        if (mounted) setApiNotifications(Array.isArray(data) ? data : []);
      })
      .catch(() => {
        if (mounted) setApiNotifications(Array.isArray(Notifications) ? Notifications : []);
      });

    return () => {
      mounted = false;
    };
  }, [Notifications, backendUrl]);

  const formatTime = (timestamp: string) => {
    const formatted = toTimestamp(timestamp);
    return formatted === "-" ? "-" : formatted.split(" ")[1];
  };

  return (
    <div className="dash2-notification-widget">
      {previewNotifications.length > 0 ? (
        <Table responsive className="dash2-notification-table" style={{ width: '100%', tableLayout: 'fixed' }}>
          <thead
            className="bg-white text-uppercase"
            style={{
              backgroundColor: 'white',
              width: '100%',
            }}
          >
            <tr className="ligth ligth-data">
              <th style={{ width: "28%" }}>{translate("Type")}</th>
              <th>{translate("Message")}</th>
              <th style={{ width: "22%" }}>{translate("Date")}</th>
            </tr>
          </thead>
          <tbody>
            {previewNotifications.map((notification: any, index: number) => (
              <tr key={notification.id_notification ?? `${notification.timestamp}-${index}`}>
                <td title={String(notification.type ?? "-")}>{notification.type ?? "-"}</td>
                <td title={String(notification.message ?? "")}>{notification.message ?? "-"}</td>
                <td>{formatTime(notification.timestamp)}</td>
              </tr>
            ))}
          </tbody>
        </Table>


      ) : (
        <div className="dash2-notification-empty">
          <i className="ri-notification-off-line" />
          <span>Aucune notification.</span>
        </div>
      )}
      {previewNotifications.length > 0 && (
        <div className="dash2-notification-footer">
          <Button as={Link as any} to="/notifications" variant="outline-primary" size="sm">
            {translate("See all notifications")}
          </Button>
        </div>
      )}
    </div>
  );

};

export default Notification;
